import React, { useEffect, useState } from "react";
import { Tabs, Tab, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
// hooks
import { useRedux } from "../../../hooks/index";
import { createSelector } from "reselect";
// components
import Loader from "../../../components/Loader";

import "bootstrap/dist/css/bootstrap.min.css";

// actions
import { getCalls } from "../../../redux/actions";

// interface
import { CallItem } from "../../../data/calls";
import EmailTemplate from "./EmailTemplate";
import InvoiceTemplate from "./InvoiceTemplate";

import LanguageSwitcher from "../../../components/LanguageSelector";
import { useTranslation } from "react-i18next";

interface IndexProps {}
const Templates = (props: IndexProps) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  // global store
  const { dispatch, useAppSelector } = useRedux();

  const errorData = createSelector(
    (state: any) => state.Calls,
    state => ({
      calls: state.calls,
      getCallsLoading: state.getCallsLoading,
    }),
  );
  // Inside your component
  const { calls, getCallsLoading } = useAppSelector(errorData);

  const [key, setKey] = React.useState<string | null>("email_template");

  // get user calls
  useEffect(() => {
    // dispatch(getCalls());
  }, [dispatch]);

  const [callsList, setCallsList] = useState([]);

  useEffect(() => {
    setCallsList(calls);
  }, [calls]);

  const handleGoToSubscriptionPage = () => {
    navigate("/subscription");
  };

  return (
    <div className="right-panel">
      <div className="sticky-top bg-white shadow-sm w-100 p-3 d-flex justify-content-between align-items-center z-index-100">
        <span className="mb-0 default-text" style={{ fontWeight: "500" }}>
          {t("Templates")}
        </span>
        <span className="d-flex gap-3">
          <LanguageSwitcher />
          <Button variant="danger" onClick={handleGoToSubscriptionPage}>
            {t("Unlock Pro")}
          </Button>
        </span>
      </div>
      <div className="py-3  px-4">
        <div id="breadcrumb" className="d-flex gap-2 my-3">
          <i className="bx bx-home font-size-22"></i>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="flex-shrink-0 h-5 w-5"
            aria-hidden="true"
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
          <span>
            <a style={{ fontWeight: "500" }}> {t("Templates")}</a>
          </span>
        </div>
        <Tabs
          id="controlled-tab-example"
          activeKey={key ?? undefined} // Convert null to undefined for compatibility
          onSelect={k => setKey(k)}
          className="mb-3 pt-3 "
        >
          <Tab
            eventKey="email_template"
            title={
              <span
                style={
                  key === "email_template"
                    ? { color: "#ff5722", fontWeight: "bold" }
                    : { color: "rgb(12 39 68)", fontWeight: "bold" }
                }
              >
                {t("Email Template")}
              </span>
            }
          >
            <div>
              <EmailTemplate />
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default Templates;
